import { render, staticRenderFns } from "./ShippingContainer.pug?vue&type=template&id=c2f6b184&scoped=true&lang=pug&"
import script from "./ShippingContainer.vue?vue&type=script&lang=js&"
export * from "./ShippingContainer.vue?vue&type=script&lang=js&"
import style0 from "./ShippingContainer.scss?vue&type=style&index=0&id=c2f6b184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f6b184",
  null
  
)

export default component.exports